import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

import PagesHeroSection from '../../components/pagesHeroSection/pagesHeroSection';
import SEOUpdater from '../../utils/hoc/SEOUpdater';
import './contactUsPage.scss';

const ContactUsPage = () => {
  const { t } = useTranslation('contactUs');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contactUsPage">
      {/* Dynamic SEO metadata */}
      <SEOUpdater page="contactUs" />

      {/* Hero section */}
      <PagesHeroSection page={t('pageTitle')} />

      {/* Contact info + maps */}
      <Container>
        <div className="row">
          {/* Glendale Office */}
          <div className="col-md-6 mb-5">
            <div className="contact-info-wrapper mb-3">
              <p className="contact-info">
                <a
                  href="https://maps.apple.com/place?address=600%20N%20Brand%20Blvd,%20Glendale,%20CA%2091203&coordinate=34.155026,-118.254627"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faLocationDot} className="me-2" />
                  <span>{t('address1')}</span>
                </a>
              </p>
              <p className="contact-info">
                <a href="tel:+18056000006">
                  <FontAwesomeIcon icon={faPhone} className="me-2" />
                  <span>+1 (805) 600-0006</span>
                </a>
              </p>
              <p className="contact-info">
                <a href="mailto:info@avagyanlaw.com">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                  <span>info@avagyanlaw.com</span>
                </a>
              </p>
            </div>
            <iframe
              title="Avagyan Law Firm - Glendale Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3735.861142066685!2d-118.25715592397296!3d34.155074512292984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c19e67489673%3A0x6b4a2b2a0477a9f3!2sAvagyan%20Law%20Firm!5e1!3m2!1sen!2sus!4v1758493873023!5m2!1sen!2sus"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Sacramento Office */}
          <div className="col-md-6 mb-5">
            <div className="contact-info-wrapper mb-3">
              <p className="contact-info">
                <a
                    href="https://maps.apple/p/bmXWhwbG-ogWWt"
                    target="_blank"
                    rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faLocationDot} className="me-2"/>
                  <span>{t('address2')}</span>
                </a>
              </p>
              <p className="contact-info">
                <a href="tel:+19169999909">
                  <FontAwesomeIcon icon={faPhone} className="me-2"/>
                  <span>+1 (916) 999-9909</span>
                </a>
              </p>
              <p className="contact-info">
                <a href="mailto:info@avagyanlaw.com">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2"/>
                  <span>info@avagyanlaw.com</span>
                </a>
              </p>
            </div>
            <iframe
                title="Avagyan Law Firm - Sacramento Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3116.401649445794!2d-121.28010152353686!3d38.639644071780154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809addef7cfa06df%3A0x888825ea9e2ef3be!2s9701%20Fair%20Oaks%20Blvd%2C%20Fair%20Oaks%2C%20CA%2095628!5e0!3m2!1sen!2sus!4v1782600248805!5m2!1sen!2sus"
                width="100%"
                height="450"
                style={{border: 0}}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ContactUsPage;
